import { render, staticRenderFns } from "./MessageBox.vue?vue&type=template&id=26dee718&"
import script from "./MessageBox.vue?vue&type=script&lang=js&"
export * from "./MessageBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\source\\locate2u-server\\Locate2u.AppPortal\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('26dee718')) {
      api.createRecord('26dee718', component.options)
    } else {
      api.reload('26dee718', component.options)
    }
    module.hot.accept("./MessageBox.vue?vue&type=template&id=26dee718&", function () {
      api.rerender('26dee718', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/MessageBox.vue"
export default component.exports